import PropTypes from 'prop-types';

const SideTextPropType = PropTypes.shape({
  before: PropTypes.string.isRequired,
  after: PropTypes.string.isRequired,
});

/** How a template's two sides read: a change's before / after, or a compare's version / current. */
export const TemplateSideLabelsPropType = PropTypes.shape({
  title: SideTextPropType.isRequired,
  copyChecksum: SideTextPropType.isRequired,
  position: PropTypes.string.isRequired,
});

/** A `template-changes` (or compare `template`) answer: the TemplateChangesModel. */
export const TemplateChangesPropType = PropTypes.shape({
  kind: PropTypes.string.isRequired,
  status: PropTypes.string,
  parts: PropTypes.arrayOf(PropTypes.object),
  totals: PropTypes.object,
  pdf: PropTypes.object,
  html: PropTypes.object,
});

/** A preview's panes, in order: which side each renders, its title, and whether it has a document. */
export const PreviewPanesPropType = PropTypes.arrayOf(
  PropTypes.shape({
    side: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    hasDocument: PropTypes.bool.isRequired,
  }),
);

/** A Prism preview's numbered changes, as its list of changes reads them. */
export const PreviewMarksPropType = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    number: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isFieldName: PropTypes.bool.isRequired,
  }),
);

/** The props EntityAuditHistory hands a template field's summary renderer. */
export const TemplateChangesetPropTypes = {
  change: PropTypes.shape({
    summary: PropTypes.shape({ kind: PropTypes.string.isRequired, data: PropTypes.object })
      .isRequired,
  }).isRequired,
  detail: PropTypes.shape({
    summary: PropTypes.shape({ auditId: PropTypes.string.isRequired }).isRequired,
  }).isRequired,
};
